<template>
  <div class="pdf">
    <el-dialog
      title="文件预览"
      :visible.sync="dialogVisible"
      :fullscreen="isFullScreen"
      @open="handleOpen"
      @close="handleClose"
      width="650px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div
        class="preview"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 1)"
        element-loading-spinner="el-icon-loading"
      >
        <!-- <iframe :src="pdfUrl"></iframe> -->
        <div class="pdf-tab">
          <el-button type="primary" size="small" @click="prePage">上一页</el-button>
          <el-button type="primary" size="small" @click="nextPage">下一页</el-button>
          <el-button type="primary" size="small" @click="clock">顺时针</el-button>
          <el-button type="primary" size="small" @click="counterClock">逆时针</el-button>
          <el-button
            type="primary"
            size="small"
            v-show="fullScreen"
            @click="fullScreen = false"
          >窗口模式</el-button>
          <el-button
            type="primary"
            size="small"
            v-show="!fullScreen"
            @click="fullScreen = true"
          >全屏模式</el-button>
          <span class="page-content">{{pageNum}} / {{pageTotalNum}}</span>
        </div>
        <div class="pdf-content">
          <pdf
            ref="pdf"
            :src="pdfUrl"
            :page="pageNum"
            :rotate="pageRotate"
            @progress="loadedRatio = $event"
            @page-loaded="pageLoaded($event)"
            @loaded="loadPdfHandler"
            @num-pages="pageTotalNum=$event"
            @error="pdfError($event)"
            @link-clicked="page = $event"
          ></pdf>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
      </span>-->
    </el-dialog>
  </div>
</template>
<script>
import pdf from 'vue-pdf';
// import { getSession, decodeURI } from '@/utils';
export default {
  name: 'Pdf',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    pdfUrl: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible: {
      handler(val, oldVal) {
        this.dialogVisible = val;
      },
      deep: true
    }
  },
  computed: {
    isFullScreen() {
      return this.fullScreen;
    }
  },
  components: {
    pdf
  },
  data() {
    return {
      dialogVisible: false,
      fullScreen: false,
      pageNum: 1,
      pageTotalNum: 1,
      pageRotate: 0,
      // 加载进度
      loadedRatio: 0,
      curPageNum: 0
      // loading: false
    };
  },
  methods: {
    clock() {
      this.pageRotate += 90;
    },
    counterClock() {
      this.pageRotate -= 90;
    },
    handleOpen() {
      this.pageRotate = 0;
      this.fullScreen = false;
      this.pageNum = 1;
    },
    loadPdfHandler(e) {
      this.pageNum = 1; // 加载的时候先加载第一页
    },
    prePage() {
      var p = this.pageNum;
      p = p > 1 ? p - 1 : this.pageTotalNum;
      this.pageNum = p;
    },
    nextPage() {
      var p = this.pageNum;
      p = p < this.pageTotalNum ? p + 1 : 1;
      this.pageNum = p;
    },
    pageLoaded(e) {
      this.curPageNum = e;
    },
    pdfError(error) {
      console.error(error);
    },
    pdfPrintAll() {
      this.$refs.pdf.print();
    },
    pdfPrint() {
      this.$refs.pdf.print(100, [1, 2]);
    },
    handleClose() {
      this.$emit('close');
    }
  }
};
</script>
<style scoped>
.page-content {
  float: right;
  font-size: 16px;
  height: 40px;
  line-height: 40px;
}
.pdf-content span {
  width: 100%;
}
.pdf-tab {
  margin-bottom: 10px;
}
.el-dialog__body {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/gov-pdf-preview/src/index.vue